import { render, staticRenderFns } from "./ModalSolicitacaoTipoLesao.vue?vue&type=template&id=12c908a4&scoped=true"
import script from "./ModalSolicitacaoTipoLesao.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoTipoLesao.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoTipoLesao.vue?vue&type=style&index=0&id=12c908a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c908a4",
  null
  
)

export default component.exports